import { getRequestContext } from './server/request-context';
import factory from '@avensia/observable';

export type {
  AsyncObservable,
  Event,
  EventListener,
  Signal,
  SignalListener,
  SyncObservable,
} from '@avensia/observable';

export const {
  createAsyncObservable,
  createEvent,
  createSignal,
  createSyncObservable,
  isAsyncObservable,
  isSyncObservable,
} = factory(() => getRequestContext()?.additional);
